import * as React from "react";

interface AboutModel {
    Authority: string;
    CoughMarshalUri: string;
    MoodleEnabled: boolean;
    MoodleUri: string;
    UpdateServiceUri: string;
    AssistekPortalEnabled: boolean;
    AssistekPortalUri: string;
    TestingAssistEnabled: boolean;
    SunriseUri: string;
    SunriseEnabled: boolean;
    SunriseClientLinkLabel: boolean;
}

interface AboutContextProviderState {
    about: AboutModel;
}

export const AboutContext = React.createContext<AboutContextProviderState | undefined>(undefined);

interface AboutContextProps {
    aboutProp: AboutModel;
    children: React.ReactNode;
}

export const AboutContextProvider = ({ aboutProp, children }: AboutContextProps) => {
    const [about, setAbout] = React.useState<AboutModel>();

    React.useEffect(() => {
        const getData = async () => {
            setAbout(aboutProp);
        }

        getData();
    }, []);

    return (
        <AboutContext.Provider
            value={{
                about: about
            }}
        >
            {children}
        </AboutContext.Provider>
    );
}

export const useAboutContextProvider = () => {
    const context = React.useContext(AboutContext);
    if (context === undefined) {
        throw new Error('useAboutContextProvider must be used within a AboutContext Provider')
    }

    return context;
}
